import React, { Component, useState, useEffect } from 'react';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import ReactDOM from "react-dom";
import { useForm } from "react-hook-form";
import Header from "../Landingpagecomponents/Header/header"
import { Grid, Typography, Paper, Box, Link } from "@material-ui/core";
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import CreateIcon from '@material-ui/icons/Create';
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Slide from "react-reveal/Slide";
import logo5 from "../Landingpagecomponents/images/logo5.png"
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import MenuIcon from '@material-ui/icons/Menu';
import YesNoQuestion from "./questiontypes/yesNoQuestion";
import PictureChoice from "./questiontypes/pictureChoice";
import MultipleChoice from "./questiontypes/multipleChoice"
import DropDownList from "./questiontypes/dropDownList"
import Question from "./question"
import {
  resolveSliderKind,
  SLIDER_CONFIGS,
  clampToConfig,
  KpiSliderRow,
} from './kpiSliders';
import InputLabel from '@material-ui/core/InputLabel';
import Skeleton from "@material-ui/lab/Skeleton";
import IconButton from '@material-ui/core/IconButton';
import { MainListItems, SecondaryListItems } from '../dashboard/user_dashboard/listItems';
import { PatientHeaderContent } from '../Landingpagecomponents/Header/headerPatient';
import SharedUserDrawer, { DRAWER_WIDTH_LG, DRAWER_WIDTH_XL } from '../dashboard/user_dashboard/SharedUserDrawer';

const drawerWidth = 223;

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://material-ui.com/">
        Virtus Physio | Your Virtual Physiotherapist
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}


function FollowUpAssessment(props) {
  const showShell = props.showShell !== false;
  const inviteToken = new URLSearchParams(window.location.search || '').get('invite_token');
  
  let { register, handleSubmit } = useForm();
  const [isStarted, setIsStarted] = useState(false);
  //const [currentSelectedAnswer, setCurrentSelectedAnswer] = useState(null)
  const [currentQuestionData, setCurrentQuestionData] = useState(null)
  const [questionQuery, setQuestionQuery] = useState([])
  const [isLoading, setIsLoading] = useState(false);
  const token = useSelector(state => state.auth.token);
  const [followupId, setFollowupId] = useState(null);
  const [prefillList, setPrefillList] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [followupAnswers, setFollowupAnswers] = useState([]);
  // Per-question slider value + editable label (function items only),
  // keyed by prefill question_id. Mirrors the clinician dialog state shape
  // so we can reuse `KpiSliderRow` directly.
  const [kpiValues, setKpiValues] = useState({});
  const [kpiLabels, setKpiLabels] = useState({});
  const [editingLabel, setEditingLabel] = useState({});

  // Adapt a prefill list entry (assessment baseline question OR a synthetic
  // clinician-added KPI) into the shape `KpiSliderRow` consumes. The shared
  // module's `resolveSliderKind` handles routing via
  // kpi_type/kpi_subtype/identifier so we just need to pass canonical fields.
  const prefillItemToKpiShape = (item) => {
    if (!item) return null;
    // Use the canonical baseline value from kpi_items.history[0] when
    // available so KpiSliderRow can render "Baseline: X | Latest: Y".
    // Falls back to numeric_value when history isn't present (no journal).
    const baselineVal = item.baseline_value != null ? item.baseline_value : item.numeric_value;
    const history = Array.isArray(item._kpiHistory) ? item._kpiHistory : [];
    if (item._isCustomKpi) {
      const kind = item._kpiKind || 'pain_current';
      const ks = kind === 'frequency' ? 'frequency'
        : kind === 'function' ? 'main_goal'
        : kind === 'pain_custom' ? 'custom'
        : kind === 'nps' ? '' : '';
      const kt = kind === 'function' ? 'function_goal'
        : kind === 'nps' ? '' : 'pain_baseline';
      // Function goals AND clinician-defined custom pain baselines both carry
      // a meaningful free-text label (the patient-described activity OR the
      // clinician-named pain metric, e.g. "pain with benchpress"). For the
      // standard pain subtypes / frequency / NPS the KpiMeasurement.label is
      // a stale snapshot of an old answer (e.g. "7/7 days in a week
      // (daily)") that must NOT show in the followup.
      const customLabel = (kind === 'function' || kind === 'pain_custom')
        ? (item._kpiLabel || item.question_text || '')
        : '';
      return {
        id: item.question_id,
        question_identifier: item.identifier || '',
        question_type: kind === 'nps' ? 'selfRated_NPS' : '',
        kpi_type: kt,
        kpi_subtype: ks,
        label: customLabel,
        numeric_value: item.numeric_value,
        baseline_value: baselineVal,
        history,
      };
    }
    const ident = (item.identifier || '').toString();
    const lower = ident.toLowerCase();
    let kt = 'pain_baseline';
    let ks = '';
    let qt = '';
    if (lower.includes('function')) {
      kt = 'function_goal';
      ks = 'main_goal';
    } else if (lower === 'selfrated_nps' || lower.includes('nps')) {
      kt = '';
      qt = 'selfRated_NPS';
    } else if (lower.includes('frequency')) {
      ks = 'frequency';
    }
    // Same rationale: only surface the free-text label for function goals.
    // Hides stale baseline-answer snapshots like "7/7 days in a week (daily)".
    const baselineLabel = kt === 'function_goal'
      ? (item._kpiLabel || item.text_value || item.question_text || '')
      : '';
    return {
      id: item.question_id,
      question_identifier: ident,
      question_type: qt,
      kpi_type: kt,
      kpi_subtype: ks,
      label: baselineLabel,
      numeric_value: item.numeric_value,
      baseline_value: baselineVal,
      history,
    };
  };

  // Seed the per-question value/label state once we know the full prefill
  // list, clamping each baseline value into its slider's valid range.
  const seedKpiState = (list) => {
    const initVals = {};
    const initLabels = {};
    list.forEach((entry) => {
      const shape = prefillItemToKpiShape(entry);
      if (!shape) return;
      const cfg = SLIDER_CONFIGS[resolveSliderKind(shape)];
      initVals[entry.question_id] = clampToConfig(shape.numeric_value, cfg);
      initLabels[entry.question_id] = shape.label || '';
    });
    setKpiValues(initVals);
    setKpiLabels(initLabels);
  };

  // Convert one prefill list entry (standard baseline question OR a synthetic
  // clinician-added KPI) into the currentQuestionData shape Question.js wants.
  // For `_isCustomKpi` items we route by KPI kind so frequency / NPS / pain /
  // function each render the right slider component.
  const buildQuestionDataFromItem = (item) => {
    if (item && item._isCustomKpi) {
      const kind = item._kpiKind || 'pain_current';
      const cfg = SLIDER_CONFIGS[kind] || SLIDER_CONFIGS.generic;
      let identifier;
      let questionType;
      let title;
      if (kind === 'frequency') {
        identifier = 'frequency_of_symptoms';
        questionType = 'selfRatedPain';
        title = 'On how many days in the last week have you had these symptoms?';
      } else if (kind === 'nps') {
        identifier = 'selfrated_nps';
        questionType = 'selfRated_NPS';
        title = 'How satisfied are you with your progress so far?';
      } else if (kind === 'function') {
        identifier = item.identifier || 'selfRatedFunction';
        questionType = 'selfRatedFunction';
        title = `How is your ability to perform "${item._kpiLabel || 'the activity below'}" today?`;
      } else {
        identifier = item.identifier || 'selfRatedPain';
        questionType = 'selfRatedPain';
        title = cfg.title || 'How is your pain right now?';
      }
      return {
        id: item.question_id,
        identifier,
        title,
        questionType,
        type: questionType,
        defaultValue: item.numeric_value,
        description: item.text_value || null,
        isFollowup: true,
        _isCustomKpi: true,
      };
    }
    const isFunction = item && item.identifier && item.identifier.toString().toLowerCase().includes('function');
    const followUpFunctionTitle = 'Please rate your ability to perform the activity you identified previously as unable to do or are having difficulty with as a result of your problem and your main goal to improve.';
    return {
      id: item.question_id,
      identifier: item.identifier,
      title: isFunction ? followUpFunctionTitle : item.question_text,
      questionType: isFunction ? 'selfRatedFunction' : 'selfRatedPain',
      type: isFunction ? 'selfRatedFunction' : 'selfRatedPain',
      defaultValue: item.numeric_value,
      description: item.text_value || item.description || null,
      descriptionPlaceholder: item.descriptionPlaceholder || null,
      isFollowup: true,
    };
  };
  
  const startFollowup = async (baseline_id = null) => {
    if (!token && !inviteToken) {
      // Not authenticated; redirect to home/login
      window.location.href = '/';
      return;
    }
    setIsLoading(true);
    try {
      const body = baseline_id ? { baseline_id } : {};
      const resp = inviteToken
        ? await fetch(`https://api.virtus-one.com/question-handler/followup/invite/${inviteToken}/`)
        : await fetch('https://api.virtus-one.com/question-handler/followup/generate/', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Token ${token}`
            },
            body: JSON.stringify(body)
          });
      if (!resp.ok) {
        setIsLoading(false);
        return;
      }
      const data = await resp.json();
      setFollowupId(data.followup_id);
      const prefill = data.prefill || [];
      // Reorder prefill so that any selfRatedFunction items are placed last
      const isFunctionItem = (item) => item && item.identifier && item.identifier.toString().toLowerCase().includes('function');
      const functions = prefill.filter(isFunctionItem);
      const others = prefill.filter((it) => !isFunctionItem(it));
      const orderedPrefill = others.concat(functions);

      // Align the patient's question set with the clinician follow-up dialog:
      // the canonical `kpi_items?in_latest_journal=1` endpoint is the source
      // of truth (same filter the clinician sees, same dedup). For each
      // kpi_item we try to find a matching baseline prefill entry (by
      // identifier) so the submission still targets the original Question.pk
      // when available. KPIs without a matching Question fall through as
      // `is_custom_kpi: true` and submit by KpiMeasurement.pk.
      //
      // Pulling baseline + latest from kpi_item.history[] lets KpiSliderRow
      // render the "Baseline: X | Latest: Y" hint for the patient too.
      let kpiItems = [];
      try {
        const kpiResp = await fetch('https://api.virtus-one.com/treatment/kpi_items/me/?in_latest_journal=1', inviteToken ? {} : {
          headers: { 'Authorization': `Token ${token}` },
        });
        if (kpiResp.ok) {
          const kpiData = await kpiResp.json();
          kpiItems = Array.isArray(kpiData && kpiData.kpi_items) ? kpiData.kpi_items : [];
        }
      } catch (e) {
        // Non-fatal: with no kpi_items we fall back to the raw prefill.
      }

      let fullPrefill;
      // Helper: identify a prefill entry as the patient NPS satisfaction
      // question. Used to (a) keep it out of the kpi_items-derived list
      // (NPS is patient-only, not a clinician journal edit) and (b)
      // re-append it as the LAST step so it always closes the follow-up.
      const isNpsItem = (it) => {
        if (!it) return false;
        const ident = (it.identifier || '').toString().toLowerCase();
        const qtype = (it.question_type || '').toString().toLowerCase();
        return ident === 'selfrated_nps' || ident.includes('nps') || qtype === 'selfrated_nps';
      };
      const npsItem = orderedPrefill.find(isNpsItem) || null;
      if (kpiItems.length > 0) {
        // Build a lookup of baseline-derived prefill entries by identifier
        // (case-insensitive) so we can preserve their `question_id`
        // (Question.pk) when an active KPI also has a baseline question.
        const prefillByIdent = new Map();
        orderedPrefill.forEach(p => {
          const ident = (p.identifier || '').toString().trim().toLowerCase();
          if (ident && !prefillByIdent.has(ident)) {
            prefillByIdent.set(ident, p);
          }
        });

        const activeKpis = kpiItems.filter(k => !k.is_deleted && !k.paused_from_followup && !isNpsItem({
          identifier: k.question_identifier,
          question_type: k.question_type,
        }));
        // Sort: pain/frequency/NPS first, function goals last (matches the
        // clinician dialog ordering).
        activeKpis.sort((a, b) => {
          const aFn = (a.kpi_type || '') === 'function_goal' ? 1 : 0;
          const bFn = (b.kpi_type || '') === 'function_goal' ? 1 : 0;
          return aFn - bFn;
        });

        fullPrefill = activeKpis.map(k => {
          const ident = (k.question_identifier || '').toString();
          const matchedBaseline = prefillByIdent.get(ident.trim().toLowerCase()) || null;
          const history = Array.isArray(k.history) ? k.history : [];
          const baselineValue = history.length > 0 && history[0].value != null
            ? history[0].value
            : k.numerical_value;
          const latestValue = k.numerical_value != null
            ? k.numerical_value
            : (history.length > 0 ? history[history.length - 1].value : null);
          const kind = resolveSliderKind({
            kpi_type: k.kpi_type,
            kpi_subtype: k.kpi_subtype,
            question_identifier: ident,
            question_type: k.question_type,
          });
          if (matchedBaseline) {
            return {
              ...matchedBaseline,
              _isCustomKpi: true,
              numeric_value: latestValue,
              baseline_value: baselineValue,
              _kpiKind: kind,
              _kpiLabel: k.label || matchedBaseline.text_value || '',
              _kpiHistory: history,
            };
          }
          return {
            question_id: k.id, // KpiMeasurement.pk — paired with is_custom_kpi:true on submit
            identifier: ident,
            question_text: k.label || '',
            numeric_value: latestValue,
            baseline_value: baselineValue,
            text_value: k.label || '',
            _isCustomKpi: true,
            _kpiKind: kind,
            _kpiLabel: k.label || '',
            _kpiHistory: history,
          };
        });
      } else {
        // No clinician journal yet → keep the original baseline-only prefill.
        // Any backend-emitted `is_custom_kpi` placeholders (numeric_value
        // null) are dropped; without history they'd just show as empty cards.
        fullPrefill = orderedPrefill.filter(p => !(p.is_custom_kpi && p.numeric_value == null) && !isNpsItem(p));
      }
      // Always close the patient follow-up with the NPS satisfaction
      // question. Pulled from the baseline-derived prefill so its
      // `question_id` is a real Question.pk and submit persists an
      // AnsweredQuestion + KpiMeasurement(SOURCE_PATIENT_FOLLOWUP) row.
      // Clinician follow-up flow is unaffected (this file is patient-only).
      if (npsItem) {
        // Drop any duplicate that slipped through, then append last.
        fullPrefill = fullPrefill.filter(p => !isNpsItem(p));
        fullPrefill.push(npsItem);
      }
      setPrefillList(fullPrefill);
      seedKpiState(fullPrefill);
      if (fullPrefill.length > 0) {
        setCurrentQuestionData(buildQuestionDataFromItem(fullPrefill[0]));
      }
      setIsStarted(true);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };
//sletmig igen
  const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
      flexGrow: 1,
      padding: theme.spacing(0),
      margin: 0,
    },
    toolbar: {
      paddingRight: 24,
    },
    // AppBar matches Overview.js exactly: 50px default, 57px on xl.
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      height: 50,
      maxHeight: 50,
      boxShadow: '0 2px 4px rgba(40,40,40,0.22), 0 2px 6px rgba(40,40,40,0.28)',
      [theme.breakpoints.up('xl')]: {
        height: 57,
        maxHeight: 57,
      },
    },
    // appBarShift mirrors Overview.js: uses SharedUserDrawer width constants.
    appBarShift: {
      marginLeft: DRAWER_WIDTH_LG,
      width: `calc(100% - ${DRAWER_WIDTH_LG}px)`,
      [theme.breakpoints.up('xl')]: {
        marginLeft: DRAWER_WIDTH_XL,
        width: `calc(100% - ${DRAWER_WIDTH_XL}px)`,
      },
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
      flexGrow: 1,
      maxWidth: '100%',
      height: '100vh',
      overflow: 'auto',
    },
    responsive: {
      width: "100%",
      height: "auto",
    },
  }));

  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const handleDrawerOpen = () => setOpen(true);
  const handleDrawerClose = () => setOpen(false);

  const ActionButton = withStyles({
    root: {
      boxShadow: "none",
      textTransform: "none",
      fontSize: 20,
      padding: "0px 40px",
      border: "1px solid",
      lineHeight: 0.5,
      backgroundColor: "#fb741a",
      borderColor: "#fb741a",
      fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"'
      ].join(","),
      "&:hover": {
        backgroundColor: "#002D55",
        borderColor: "#002D55",
        boxShadow: "none"
      },
      "&:active": {
        boxShadow: "none",
        backgroundColor: "#0062cc",
        borderColor: "#005cbf"
      },
      "&:focus": {
        boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)"
      }
    }
  })(Button);

  const StartItem = <Box
    component="form"
    className="followup-card-responsive"
    onSubmit={handleSubmit(onSubmit)}
    style={{
      width: '100%',
      background: '#f7faff',
      border: '1px solid rgba(0, 45, 85, 0.1)',
      borderRadius: 22,
      padding: 'clamp(20px, 2.4vw, 36px)',
      boxSizing: 'border-box',
      boxShadow: '0 6px 24px rgba(0,45,85,0.08)',
      textAlign: 'center',
    }}
  >
      {/*<img src={logo5} className="assessment-logo-responsive" style={{ borderRadius: 12, margin: 0, marginBottom: 10, maxWidth: 500, minWidth: 200, width: "20vw", height: "auto" }} />*/}
      <Typography
        variant="body1"
        className="assessment-title-responsive2"
        style={{ color: "#002D55", fontWeight: 300, marginBottom: 10, whiteSpace: "pre-line" }}
      >
        <span style={{display: 'inline-flex', alignItems: 'center'}}>
          <CreateIcon className="assessment-title-responsive2" style={{verticalAlign: 'middle', marginRight: 8, color: '#fb741a'}} />
          <span  className="assessment-title-responsive2" style={{ verticalAlign: 'middle'}}>Weekly Physio Check-in</span>
        </span>
      
        
      </Typography>
      <Box
        style={{
          borderTop: '1px solid rgba(0, 45, 85, 0.12)',
          marginBottom: 24,
        }}
      />
      <Typography
        variant="body1"
        className="assessment-title-responsive"
        style={{ color: "#002D55", fontWeight: 300, marginBottom: 10 }}
      >
        Update us on your recovery process to ensure everything is going according to plan. 
      </Typography>
       <Typography
        variant="body1"
        className="assessment-title-responsive"
        style={{ color: "#002D55", fontWeight: 300, marginBottom: 10 }}
      >
        Please take your time to answer the following questions honestly and thoroughly.
      </Typography>
      <Typography
        variant="body1"
        className="assessment-title-responsive"
        style={{ color: "#486d86", fontWeight: 300, marginBottom: 24 }}
      >
        Estimated time: 3-5 minutes.
      </Typography>

    <style>{`
      @media (max-width: 600px) {
        .assessment-title-responsive { max-width: 550px; font-size: 1.08rem !important; }
        .assessment-title-responsive2 { max-width: 550px; font-size: 1.38rem !important; }
      }
      @media (min-width: 601px) and (max-width: 960px) {
        .assessment-title-responsive { max-width: 550px; font-size: 1.13rem !important; }
        .assessment-title-responsive2 { max-width: 550px; font-size: 1.43rem !important; }
      }
      @media (min-width: 960px) and (max-width: 1280px) {
        .assessment-title-responsive { max-width: 570px; font-size: 1.18rem !important; }
        .assessment-title-responsive2 { max-width: 570px; font-size: 1.58rem !important; }
      }
      @media (min-width: 1280px) and (max-width: 1920px) {
        .assessment-title-responsive { max-width: 650px; font-size: 1.3rem !important; }
        .assessment-title-responsive2 { max-width: 650px; font-size: 1.67rem !important; }
      }
      @media (min-width: 1920px) {
        .assessment-title-responsive { max-width: 700px; font-size: 1.5rem !important; }
        .assessment-title-responsive2 { max-width: 700px; font-size: 1.78rem !important; }
      }
    `}</style>

    <ActionButton variant="contained" disableRipple style={{ marginBottom: 5, borderRadius: 24 }}
      onClick={async () => { await startFollowup() }}><h3 className="assessment-button-responsive" style={{fontSize: "1.1rem", margin: 0, padding: 19}}>I UNDERSTAND</h3></ActionButton>
    <style>{`
      @media (max-width: 600px) {
        .assessment-title-responsive { font-size: 0.85rem !important; }
        .assessment-button-responsive { font-size: 0.80rem !important; }
      }
      @media (min-width: 600px) and (max-width: 960px) {
        .assessment-title-responsive { font-size: 0.95rem !important; }
        .assessment-button-responsive { font-size: 0.90rem !important; }
      }
      @media (min-width: 960px) and (max-width: 1280px) {
        .assessment-title-responsive { font-size: 1.0rem !important; }
        .assessment-button-responsive { font-size: 0.9rem !important; }
      }
      @media (min-width: 1280px) and (max-width: 1920px) {
        .assessment-title-responsive { font-size: 1.1rem !important; }
        .assessment-button-responsive { font-size: 1.0rem !important; }
      }
      @media (min-width: 1920px) {
        .assessment-title-responsive { font-size: 1.2rem !important; }
        .assessment-button-responsive { font-size: 1.1rem !important; }
      }
      @media (min-width: 960px) and (max-width: 1280px) {
        .assessment-title-responsive { line-height: 1.35 !important; }
        .assessment-title-responsive br { display: none !important; }
      }
      @media (max-width: 600px) {
        .assessment-logo-responsive { max-width: 215px !important; min-width: 100px !important; width: 60vw !important; }
      }
      @media (min-width: 600px) and (max-width: 960px) {
        .assessment-logo-responsive { max-width: 260px !important; min-width: 140px !important; width: 45vw !important; }
      }
      @media (min-width: 960px) and (max-width: 1280px) {
        .assessment-logo-responsive { max-width: 340px !important; min-width: 180px !important; width: 40vw !important; }
      }
      @media (min-width: 1280px) {
        .assessment-logo-responsive { max-width: 500px !important; min-width: 200px !important; width: 32vw !important; }
      }
    `}</style>
  </Box>;

  const submitFollowupAnswers = async (answers) => {
    setIsLoading(true);
    try {
      const resp = inviteToken
        ? await fetch(`https://api.virtus-one.com/question-handler/followup/invite/${inviteToken}/submit/`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ answers })
          })
        : await fetch(`https://api.virtus-one.com/question-handler/followup/${followupId}/submit/`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Token ${token}` },
            body: JSON.stringify({ answers })
          });
      if (resp.ok) {
        setIsLoading(false);
        localStorage.setItem('vp_last_followup_answered_at', new Date().toISOString());
        window.location.href = inviteToken ? '/' : '/overview_of_journey';
      } else {
        setIsLoading(false);
      }
    } catch (err) {
      setIsLoading(false);
    }
  };

  const nextQuestionHandler = async (answer) => {
    // If we're in followup mode (prefill flow), handle locally and submit at end
    if (followupId && prefillList && prefillList.length > 0) {
      if (answer == null) return;
      // record the answer for currentIndex
      const q = prefillList[currentIndex];
      // include baseline description from prefill when patient doesn't provide one
      const ansPayload = (typeof answer === 'object') ? answer : { value: Number(answer) };
      if (!ansPayload.description) {
        ansPayload.description = q.text_value || q.description || null;
      }
      const ansItem = q._isCustomKpi
        ? { question_id: q.question_id, answer: ansPayload, is_custom_kpi: true }
        : { question_id: q.question_id, answer: ansPayload };
      setFollowupAnswers(prev => prev.concat([ansItem]));

      // move to next
      const nextIdx = currentIndex + 1;
      if (nextIdx < prefillList.length) {
        setCurrentIndex(nextIdx);
        setCurrentQuestionData(buildQuestionDataFromItem(prefillList[nextIdx]));
      } else {
        const allAnswers = followupAnswers.concat([ansItem]);
        await submitFollowupAnswers(allAnswers);
      }
      return;
    }

    // legacy flow: continue using existing fetchNextQuestion behavior
    if (!isLoading && answer != null && currentQuestionData != null && answer.replace(" ", "") != "") {
      var newQuery = questionQuery.concat([{ "id": currentQuestionData.id, "answer": answer }]);
      setIsLoading(true); // Start loader

      // Set pause duration based on number of answered questions
      const thinkingPause = questionQuery.length < 10 ? 550 : 1550; // 0.4s if less than 8, else 1.55s

      setTimeout(async () => {
        setQuestionQuery(newQuery);
        await fetchNextQuestion(newQuery);
        setIsLoading(false); // Stop loader after fetch
      }, thinkingPause);
    }
  };

  //Fjerner 1 objekt fra query listen i backen og fetcher newQuery igen
  const previousQuestionHandler = () => {
    if (isLoading) return;

    // If we're in follow-up/prefill flow, handle going back locally
    if (followupId && prefillList && prefillList.length > 0) {
      // If we're at the first prefill question, return to the start screen
      if (currentIndex <= 0) {
        setIsStarted(false);
        setCurrentIndex(0);
        setFollowupAnswers([]);
        setCurrentQuestionData(null);
        return;
      }

      // Move back one index and remove last recorded followup answer
      const prevIdx = currentIndex - 1;
      setCurrentIndex(prevIdx);
      setCurrentQuestionData(buildQuestionDataFromItem(prefillList[prevIdx]));
      setFollowupAnswers(prev => prev.slice(0, Math.max(0, prev.length - 1)));
      return;
    }

    // Legacy flow: remove last item from query and fetch next question from server
    var newQuery = questionQuery.slice(0, questionQuery.length - 1);
    setQuestionQuery(newQuery)
    fetchNextQuestion(newQuery)
  }

  const KpiFollowupScreen = null;

  // Stepper rendered above the live Question while we walk the prefill list.
  // Mirrors the dot-progress styling used in the clinician follow-up dialog
  // so the patient knows how many steps remain. Hidden on legacy / non-prefill
  // flows where prefillList is empty.
  const StepperBar = (isStarted && prefillList && prefillList.length > 1) ? (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 16 }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {prefillList.map((_, i) => {
          const isDone = i < currentIndex;
          const isCurrent = i === currentIndex;
          return (
            <span
              key={i}
              style={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                margin: '0 4px',
                background: isDone ? '#002D55' : isCurrent ? '#FF7F27' : '#cbd5e1',
                transition: 'background 150ms ease',
              }}
            />
          );
        })}
      </div>
      <div style={{ color: '#94a3b8', fontSize: 12, marginTop: 6, letterSpacing: 0.2 }}>
        Question {currentIndex + 1} of {prefillList.length}
      </div>
    </div>
  ) : null;

  // Submit handler used by the in-card pill button. Records the current
  // slider value as the answer for prefillList[currentIndex] and either
  // advances or POSTs the full followup payload.
  const submitCurrentStep = async () => {
    if (!followupId || !prefillList || prefillList.length === 0) return;
    if (isLoading) return;
    const q = prefillList[currentIndex];
    if (!q) return;
    const value = kpiValues[q.question_id];
    if (value == null || Number.isNaN(Number(value))) return;
    const ansPayload = { value: Number(value) };
    if (q._isCustomKpi) {
      // For function-style custom KPIs the editable label is the goal text.
      const editedLabel = kpiLabels[q.question_id];
      if (editedLabel != null && editedLabel !== '') {
        ansPayload.description = editedLabel;
      } else {
        ansPayload.description = q.text_value || q.description || null;
      }
    } else {
      ansPayload.description = q.text_value || q.description || null;
    }
    const ansItem = q._isCustomKpi
      ? { question_id: q.question_id, answer: ansPayload, is_custom_kpi: true }
      : { question_id: q.question_id, answer: ansPayload };
    const nextIdx = currentIndex + 1;
    if (nextIdx < prefillList.length) {
      setFollowupAnswers(prev => prev.concat([ansItem]));
      setCurrentIndex(nextIdx);
      setCurrentQuestionData(buildQuestionDataFromItem(prefillList[nextIdx]));
    } else {
      const allAnswers = followupAnswers.concat([ansItem]);
      await submitFollowupAnswers(allAnswers);
    }
  };

  const goBackStep = () => {
    if (isLoading) return;
    if (!followupId || !prefillList || prefillList.length === 0) return;
    if (currentIndex <= 0) {
      setIsStarted(false);
      setCurrentIndex(0);
      setFollowupAnswers([]);
      setCurrentQuestionData(null);
      return;
    }
    const prevIdx = currentIndex - 1;
    setCurrentIndex(prevIdx);
    setCurrentQuestionData(buildQuestionDataFromItem(prefillList[prevIdx]));
    setFollowupAnswers(prev => prev.slice(0, Math.max(0, prev.length - 1)));
  };

  // Patient follow-up card body. Visually mirrors the clinician
  // follow-up dialog (same `KpiSliderRow`, dot stepper, navy/orange
  // palette, pill-shaped Back/Next buttons) but renders ONE question at
  // a time. Falls back to the legacy `<Question />` flow only when
  // `followupId` was never set (e.g. legacy questionnaire-engine path).
  const FollowupCard = (() => {
    if (!isStarted) return null;
    if (!followupId || !prefillList || prefillList.length === 0) {
      // Legacy questionnaire-engine path — keep the original Question UI.
      return (
        <>
          {StepperBar}
          <Question
            questionData={currentQuestionData}
            nextQuestionHandler={nextQuestionHandler}
            questionClassName="assessment-question-responsive"
          />
        </>
      );
    }
    const currentItem = prefillList[currentIndex];
    const shape = prefillItemToKpiShape(currentItem);
    const isLast = currentIndex >= prefillList.length - 1;
    const hasValue = shape && kpiValues[currentItem.question_id] != null;
    return (
      <Box
        className="followup-card-responsive"
        style={{
          width: '100%',
          background: '#f7faff',
          border: '1px solid rgba(0, 45, 85, 0.1)',
          borderRadius: 22,
          padding: 'clamp(20px, 2.4vw, 36px)',
          boxSizing: 'border-box',
          boxShadow: '0 6px 24px rgba(0,45,85,0.08)',
        }}
      >
        <style>{`
          /* Per-breakpoint widths so the card grows visibly on sm/md/lg/xl
             while staying responsive. Wrapping page applies zoom: 0.88
             (and 0.93 ≥1920px), so we compensate with larger vw values. */
          .followup-card-responsive { max-width: 100%; }
          @media (min-width: 600px) {
            .followup-card-responsive { max-width: 96vw !important; }
          }
          @media (min-width: 960px) {
            .followup-card-responsive { max-width: 92vw !important; }
          }
          @media (min-width: 1280px) {
            .followup-card-responsive { max-width: 88vw !important; }
          }
          @media (min-width: 1920px) {
            .followup-card-responsive { max-width: 1800px !important; }
          }
        `}</style>
        <Box mb={2}>
          <Typography
            style={{
              fontWeight: 700,
              color: '#002D55',
              fontSize: 'clamp(18px, 1.6vw, 28px)',
              textAlign: 'left',
            }}
          >
            Weekly Physio Check-in
          </Typography>
        </Box>
        {prefillList.length > 1 && (
          <Box display="flex" flexDirection="column" alignItems="center" mb={2}>
            <Box display="flex" alignItems="center">
              {prefillList.map((_, i) => {
                const isDone = i < currentIndex;
                const isCurrent = i === currentIndex;
                return (
                  <span
                    key={i}
                    style={{
                      width: 'clamp(8px, 0.8vw, 14px)',
                      height: 'clamp(8px, 0.8vw, 14px)',
                      borderRadius: '50%',
                      margin: '0 5px',
                      background: isDone ? '#002D55' : isCurrent ? '#FF7F27' : '#cbd5e1',
                      transition: 'background 150ms ease',
                    }}
                  />
                );
              })}
            </Box>
            <Typography
              style={{
                color: '#94a3b8',
                fontSize: 'clamp(12px, 1.0vw, 16px)',
                marginTop: 8,
                letterSpacing: 0.2,
              }}
            >
              Question {currentIndex + 1} of {prefillList.length}
            </Typography>
          </Box>
        )}
        {shape && (
          <KpiSliderRow
            item={shape}
            value={kpiValues[currentItem.question_id]}
            onChange={(_qid, val) =>
              setKpiValues(prev => ({ ...prev, [currentItem.question_id]: val }))
            }
            labelText={kpiLabels[currentItem.question_id]}
            onLabelChange={(_qid, val) =>
              setKpiLabels(prev => ({ ...prev, [currentItem.question_id]: val }))
            }
            isEditingLabel={!!editingLabel[currentItem.question_id]}
            onLabelEditToggle={(_qid, b) =>
              setEditingLabel(prev => ({ ...prev, [currentItem.question_id]: b }))
            }
            allowGoalEdit={!!currentItem._isCustomKpi || (currentItem.identifier || '').toLowerCase().includes('function')}
            showBaseline
            size="large"
          />
        )}
        <Box display="flex" alignItems="center" mt={3} style={{ gap: 12 }}>
          <Button
            onClick={goBackStep}
            disabled={isLoading}
            variant="outlined"
            style={{
              color: '#002D55',
              borderColor: '#002D55',
              borderRadius: 999,
              textTransform: 'none',
              fontWeight: 600,
              fontSize: 'clamp(13px, 0.9vw, 15px)',
              padding: 'clamp(7px, 0.65vw, 10px) clamp(16px, 1.4vw, 22px)',
            }}
          >
            Back
          </Button>
          <Box flex={1} />
          <Button
            onClick={submitCurrentStep}
            disabled={isLoading || !hasValue}
            variant="contained"
            disableElevation
            style={{
              background: '#FF7F27',
              color: '#fff',
              fontWeight: 700,
              borderRadius: 999,
              textTransform: 'none',
              fontSize: 'clamp(13px, 0.9vw, 15px)',
              padding: 'clamp(7px, 0.65vw, 10px) clamp(18px, 1.6vw, 24px)',
            }}
          >
            {isLast ? (isLoading ? 'Submitting…' : 'Submit') : 'Next'}
          </Button>
        </Box>
      </Box>
    );
  })();

  //Kalder question function med de forskellige questiontypes afhængig af spørgeskemalogik
  const ViewItem = !isStarted ? StartItem : FollowupCard;

  // Hide the legacy footer Back button while we're in the new in-card
  // followup UI — that card carries its own pill-shaped Back/Submit
  // buttons. The legacy Back button still shows on the deprecated
  // questionnaire-engine path (no followupId).
  const showBackButton = isStarted && currentQuestionData != null
    && !(followupId && prefillList && prefillList.length > 0);

  //Henter næste spørgsmål fra database ud fra spørgsmål der ligger i query og logik
  const fetchNextQuestion = async (query) => {
    setIsLoading(true)
    const response = await fetch("https://api.virtus-one.com/question-handler/submit-query", {
      method: "POST",
      headers: {
        "content-type": "application/json"
      },
      body: query.length > 0 ? JSON.stringify({
        data: query,
        status: "RUNNING"
      }) : JSON.stringify({
        data: null,
        status: "REASSESS"
      })
    })

    if (response.ok) {
      const data = await response.json()
      const q = data.question;
      // If this question has a pre-stored CV answer (from dual-side capture),
      // answer it transparently without showing it to the patient.
      const prefillKey = q?.identifier ? `cv_dual_prefill:${q.identifier}` : null;
      const prefillRaw = prefillKey ? localStorage.getItem(prefillKey) : null;
      if (prefillRaw) {
        try {
          const prefill = JSON.parse(prefillRaw);
          if (prefill?.answerId) {
            localStorage.removeItem(prefillKey);
            const autoQuery = query.concat([{ id: q.id, answer: prefill.answerId }]);
            setQuestionQuery(autoQuery);
            await fetchNextQuestion(autoQuery);
            setIsLoading(false);
            return;
          }
        } catch (e) { /* malformed prefill — fall through and show the question */ }
      }
      setCurrentQuestionData(q)

    } else {
      //display error
    }
    setIsLoading(false)
  }

  // Function der tilføjer nuværrende spørgmålID og svar til questionQuery

  const handleCloseAssessment = () => {
    const target = inviteToken ? '/' : '/overview_of_journey';
    try {
      if (window.top && window.top !== window.self) {
        window.top.location.href = target;
        return;
      }
    } catch (err) {
      // Fallback to same-window navigation if cross-origin access is blocked
    }
    window.location.href = target;
  };

  const assessmentContent = (
    <Grid
      container
      style={{
        background: "linear-gradient(90deg, #dce4eb, #d7d4cf)",
        minHeight: "92vh",
        alignItems: "center",
        justifyContent: "center",
        padding: 12,
        paddingTop: 28
      }}
      className="assessment-root-zoom"
    >
      <style>{`
        .assessment-close-btn {
          border-radius: 999px;
          transition: background-color 150ms ease, box-shadow 150ms ease;
        }
        .assessment-close-btn:hover {
          border-radius: 999px;
          background-color: rgba(0, 45, 85, 0.12);
          box-shadow: 0 2px 10px rgba(0, 45, 85, 0.18);
        }
      `}</style>
      <style>{`
        @media (min-width: 600px) {
          .assessment-root-zoom { zoom: 0.88; }
        }
        @media (min-width: 1920px) {
          .assessment-root-zoom { zoom: 0.93; }
        }
        @media (min-width: 2560px) {
          .assessment-root-zoom { zoom: 0.98; }
        }
      `}</style>
      <div className="followup-close-wrap">
        <style>{`
          .followup-close-wrap {
            position: absolute;
            top: clamp(60px, 6vw, 90px);
            left: clamp(50px, 5vw, 80px);
            z-index: 1000;
            padding: 6px;
          }
          .followup-close-btn {
            border-radius: 999px !important;
            background: #ffffff !important;
            color: #000 !important;
            box-shadow: 0 2px 8px rgba(0,0,0,0.12) !important;
            padding: clamp(4px, 0.5vw, 8px) !important;
            min-width: clamp(32px, 2.8vw, 44px) !important;
            min-height: clamp(32px, 2.8vw, 44px) !important;
            font-size: clamp(12px, 1.0vw, 16px) !important;
            font-weight: 700 !important;
            transition: background-color 150ms ease, box-shadow 150ms ease !important;
          }
          .followup-close-btn:hover {
            background-color: rgba(0, 45, 85, 0.12) !important;
            box-shadow: 0 2px 10px rgba(0, 45, 85, 0.18) !important;
          }
        `}</style>
        <IconButton
          className="followup-close-btn"
          onClick={handleCloseAssessment}
        >
          <span style={{ fontSize: 'clamp(12px, 1.0vw, 18px)', fontWeight: 500, lineHeight: 1, paddingTop: 2 }}>X</span>
        </IconButton>
      </div>
      <Paper
        elevation={3}
        style={{
          background: "transparent",
          borderRadius: 40,
          padding: 16,
          marginLeft: 10,
          marginRight: 10,
          marginTop: 10,
          marginBottom: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          transition: "min-height 0.2s, width 0.2s"
        }}
      >
        <style>{`
          @media (max-width: 600px) {
            .assessment-question-responsive { font-size: 1.05rem !important; }
          }
          @media (min-width: 600px) and (max-width: 960px) {
            .assessment-question-responsive { font-size: 1.13rem !important; }
          }
          @media (min-width: 960px) and (max-width: 1280px) {
            .assessment-question-responsive { font-size: 1.18rem !important; }
          }
          @media (min-width: 1280px) and (max-width: 1920px) {
            .assessment-question-responsive { font-size: 1.3rem !important; }
          }
          @media (min-width: 1920px) {
            .assessment-question-responsive { font-size: 1.5rem !important; }
          }
        `}</style>
        <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
          {ViewItem}
        </div>
        <Grid
          container
          direction="row"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%"
          }}
        >
          {isLoading ? (
            <>
              <style>
                {`
                  @keyframes pulseText {
                    0% { opacity: 1; }
                    50% { opacity: 0.4; }
                    100% { opacity: 1; }
                  }
                `}
              </style>
              <Grid
                container
                direction="row"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  marginTop: 15,
                }}
              >
                <Typography
                  style={{
                    marginLeft: 16,
                    color: "#fb741a",
                    fontSize: 20,
                    fontWeight: 600,
                    animation: "pulseText 1s infinite"
                  }}
                >
                  {/* Thinking */}
                </Typography>
                <Skeleton variant="circular" width={8} height={8} animation="pulse" style={{ margin: "0 8px", marginBottom: 5, background: "#fb741a" }} />
                <Skeleton variant="circular" width={8} height={8} animation="pulse" style={{ margin: "0 8px", marginBottom: 5, background: "#fb741a" }} />
                <Skeleton variant="circular" width={8} height={8} animation="pulse" style={{ margin: "0 8px", marginBottom: 5, background: "#fb741a" }} />
              </Grid>
            </>
          ) : (
            showBackButton ? (
              <Button
                className="assessment-button-responsive"
                style={{
                  color: "#888",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: 5,
                }}
                onClick={previousQuestionHandler}
              >
                Back
              </Button>
            ) : null
          )}
        </Grid>
      </Paper>
    </Grid>
  );

  if (!showShell) {
    return assessmentContent;
  }

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar style={{ top: 0, color: "#002D55", backgroundColor: "#FFFFFF" }} position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
        <Toolbar className={classes.toolbar}>
          <PatientHeaderContent
            onProfile={() => window.location.replace('/myaccount?tab=profile')}
            onOpenVideo={() => {}}
            onOpenCheckin={() => {}}
          />
        </Toolbar>
      </AppBar>
      <SharedUserDrawer open={open} onOpen={handleDrawerOpen} onClose={handleDrawerClose} />
      <main className={classes.content} style={{ background: 'linear-gradient(90deg, #dce4eb, #d7d4cf)' }}>
        <div className={classes.appBarSpacer} />
        {assessmentContent}
        
<Box
        width="100%"
        style={{
          position: "fixed",
          left: 0,
          bottom: 0,
          background: "#fff",
          zIndex: 10,
          boxShadow: "0 -2px 8px rgba(0,0,0,0.04)",
          padding: "16px 0",
          background: "linear-gradient(90deg, #dce4eb, #d7d4cf)",
        }}
      >
        <Copyright />
      </Box>
      </main>
    </div>
  );
}

function onSubmit(values) {
  console.log(values)
}

export default FollowUpAssessment;